import { KING_VALUE } from 'constants/cards';
import { SolitaireGame } from 'game/SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';

// The priority of the area for card selection:
// 1. Tableau (hidden cards)
// 2. Wastepile
// 3. Stockpile

export function findKlondikeMagic(game: SolitaireGame): [MagicItem | null, MagicItem | null] {
    const items = getCardFromPlace([
        ...getCardsForFirstCase(game),
        ...getCardsForSecondCase(game),
        ...getCardsForThirdCase(game),
    ], game);

    return items;
}


function getCardFromPlace(hiddenCards: Card[], game: SolitaireGame): [MagicItem | null, MagicItem | null] {
    const validCardsToMove = [] as { priority: number; card: Card; to: GameBoardPlace; targetCard: Card | null }[];

    hiddenCards.forEach((c) => {
        if (validCardsToMove.find(item => item.card.code === c.code)) {
            return;
        }

        let hasAdded = false;

        //1. check if King can be move to empty column
        if (c.value === KING_VALUE) {
            game.columns.filter((c) => c.isEmpty).forEach((emptyColumn) => {
                if (!hasAdded && emptyColumn && !validCardsToMove.find(item => item.to === emptyColumn)) {
                    validCardsToMove.push({ priority: 0, card: c, to: emptyColumn, targetCard: null });
                    hasAdded = true;
                }
            });
        }
        //2. check foundation
        game.foundations.filter((foundation) => foundation.canDropCard([c])).forEach((validFoundation) => {
            if (!hasAdded && validFoundation && !validCardsToMove.find(item => item.to === validFoundation)) {
                validCardsToMove.push({ priority: c.value, card: c, to: validFoundation, targetCard: null });
                hasAdded = true;
            }
        });
        
        //3. check if card can be moved to any column
        game.columns.filter((column) => column.canDropCards([c])).forEach((validColumn) => {
            if (!hasAdded && validColumn && !validCardsToMove.find(item => item.to === validColumn)) {
                validCardsToMove.push({ priority: 20, card: c, to: validColumn, targetCard: validColumn.lastCard });
                hasAdded = true;
            }
        });
    });
    validCardsToMove.sort((a, b) => a.priority - b.priority);

    const firstItem = validCardsToMove.length ? new MagicItem(
        validCardsToMove[0].card,
        validCardsToMove[0].to,
        MagicPlace.AFTER,
        validCardsToMove[0].targetCard
    ) : null;

    const secondItem = validCardsToMove.length > 1 ? new MagicItem(
        validCardsToMove[1].card,
        validCardsToMove[1].to,
        MagicPlace.AFTER,
        validCardsToMove[1].targetCard
    ) : null;
    
    return [firstItem, secondItem];
}
function getCardsForFirstCase(game: SolitaireGame) {
    // ==== CHECK 1: Tableau (hidden cards). ====
    // If there is an empty column, MW draws a King.
    // MW select cards for the foundation area (starting with the smaller card).
    // Creating or continuing any sequence in the tableau area.
    const hiddenCards = [] as Card[];
    game.columns.forEach((column) =>
        column.cards.forEach((c) => {
            if (!c.visible) hiddenCards.push(c);
        })
    );
    return hiddenCards;
}

function getCardsForSecondCase(game: SolitaireGame) {
    // ==== CHECK 2: Moving a card from one column to another to uncover a face-down card in the Tableau area. ====
    if (!game.wastePile) return []; //only for type there is always waste pile in Klondike
    const westPileLength = game.wastePile?.length;
    const hiddenCards = game.wastePile.cards.filter((c, i) => i < westPileLength - 1);
    return hiddenCards;
} 
function getCardsForThirdCase(game: SolitaireGame) {
    // ==== CHECK 3: Moving a card from one column to another to uncover a face-down card in the Tableau area. ====

    const hiddenCards = game.stockPile.cards;
    return hiddenCards;
}
